import { render, staticRenderFns } from "./SettingsCreateDepartment.vue?vue&type=template&id=697823d9&scoped=true"
import script from "./SettingsCreateDepartment.vue?vue&type=script&lang=js"
export * from "./SettingsCreateDepartment.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateDepartment.vue?vue&type=style&index=0&id=697823d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697823d9",
  null
  
)

export default component.exports